var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 21.375L22 32V10.625L40.625 21.375ZM54 37.375V5.375H6V37.375H54ZM54 0C55.5 0 56.75 0.541667 57.75 1.625C58.8333 2.625 59.375 3.875 59.375 5.375L59.25 37.375C59.25 38.7917 58.7083 40.0417 57.625 41.125C56.625 42.125 55.4167 42.625 54 42.625H40.625V48H19.375V42.625H6C4.5 42.625 3.20833 42.125 2.125 41.125C1.125 40.125 0.625 38.875 0.625 37.375V5.375C0.625 3.875 1.125 2.625 2.125 1.625C3.20833 0.541667 4.5 0 6 0H54Z",
    fill: "#DEDFE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertVideo);
export default __webpack_public_path__ + "static/media/insert-video.96b426ac.svg";
export { ForwardRef as ReactComponent };